<script>
    import Loader from './shared/components/loader/Loader.svelte'

    let Router = $state()

    const init = async () => {
        Router = (await import('./pages/Router.svelte')).default
    }
</script>

{#await init()}
    <div class="absolute top-[calc(50%-1.25rem)] left-[calc(50%-1.25rem)]">
        <Loader size="large"></Loader>
    </div>
{:then}
    <Router></Router>
{:catch}
    System Maintenance
{/await}
